import { doDownload, doGet, doPatch, doPost } from "../base";

const BASE_URL = "/user_auth/local_services";

export const fetchServices = async () => {

    return await doGet(BASE_URL).catch((error) => {
        throw error;
    });
};

export const fetchLog = async (id) => {
    const endpoint = BASE_URL + `/logs/download?id=${id}`;

    return await doDownload(endpoint).catch((error) => {
        throw error;
    });
};

export const updateAction = async ({ id, type }) => {
    const endpoint = BASE_URL + `/${id}/action`;

    return await doPatch({ type }, endpoint).catch((error) => {
        throw error;
    });
};

export const fetchPersistenceFile = async (id) => {
    const endpoint = BASE_URL + `/${id}/config`;

    return await doDownload(endpoint).catch((error) => {
        throw error;
    });
};

export const update = async (pharmacyId) => {

    if (!pharmacyId) throw new Error("pharmacyId is mandatory");

    return await doPost({ pharmacyId }, BASE_URL).catch((error) => {
        throw error;
    });
};

export const create = async (pharmacyId) => {
    return await doPost({ pharmacyId }, BASE_URL).catch((error) => {
        throw error;
    });
};


export const getUnresolvedEvents = async () => {
    const endpoint = BASE_URL + `/events?unresolved=true`;
    return await doGet(endpoint).catch((error) => {
        throw error;
    });
};